import {useMapContext} from '@/components/MindMap/index.mjs'

export default () => {
    const map = useMapContext()
    const canPushProduct = map.useCanPushProduct()
    const canSaveMap = map.useCanSaveMap()

    if (! canSaveMap) {
        return null
    }

    return {
        key: 'save-map',
        label: canPushProduct ? '保存不更新' : '保存',
        suffix: canPushProduct ? '' : 'Ctrl+S',
        onClick: () => map.cmdSaveMap(),
    }
}
